/** @format */

import {getDate, startOfDay, startOfMonth, sub} from 'date-fns';

import {Chart} from 'components/charts/multiline-chart/model/charts';

import {MIN_CHART_DAYS} from './constants';

export const computeTailDays = (now: Date): number => {
  const dayOfMonth = getDate(now);
  if (dayOfMonth >= 2 && dayOfMonth <= MIN_CHART_DAYS) {
    return MIN_CHART_DAYS - (dayOfMonth - 1);
  }
  return 0;
};

export const computeEffectiveStartDate = (startDate: Date, tailDays: number, now: Date): Date => {
  if (tailDays > 0) {
    return startOfDay(sub(startOfMonth(now), {days: tailDays}));
  }
  return startDate;
};

export const removePlanFromTail = <T extends string>(
  charts: Chart<T>[],
  tailDays: number,
): void => {
  if (tailDays <= 0) return;
  charts.forEach(chart => {
    for (let i = 0; i < tailDays && i < chart.chartsData.length; i++) {
      delete chart.chartsData[i].line;
      delete chart.chartsData[i].lineSecondary;
    }
  });
};
